import { render, staticRenderFns } from "./medidas-preventivas.vue?vue&type=template&id=8cab4a4a&scoped=true&"
import script from "./medidas-preventivas.vue?vue&type=script&lang=js&"
export * from "./medidas-preventivas.vue?vue&type=script&lang=js&"
import style0 from "./medidas-preventivas.vue?vue&type=style&index=0&id=8cab4a4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cab4a4a",
  null
  
)

export default component.exports